<style scoped lang="less">
.isfivesimg {
	width: 6rem !important;
	height: 6rem !important;
}

.isfives {
	display: flex;
	flex-direction: column;
	height: auto !important;
	justify-content: space-between;

	.usertexts {
		border-left: 0 !important;
		margin-top: 1rem;
		width: 100%;

		li {
			width: 40%;
			margin: 0 0.4rem 0 0;
			text-align: center;
		}
	}
}

.userheadertx {
	border-radius: 50%;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
	border-color: #07b446;
	background: #07b446;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
	color: #333;
}

@media (min-width: 768px) and (max-width: 991px) {
	.col-md-12 {
		margin-top: 1rem;
		border-left: 0px !important;

		.userheadertx {
			width: 15vw !important;
			height: 15vw !important;
			border-radius: 50%;
		}

		.userheader {
			height: 26vh !important;
		}

		.qmedit {
			// width: 80%;
			input {
				width: 80%;
			}
		}
	}
}

@media (min-width: 576px) and (max-width: 767px) {
	.col-sm-12 {
		margin-top: 1rem;
		border-left: 0px !important;

		.userheadertx {
			width: 15vw !important;
			height: 15vw !important;
		}

		.userheader {
			height: 26vh;
		}
	}
}

@media (min-width: 992px) {
	.col-lg-3.usertexts {
		margin-top: 0 !important;
		border-left: 15px solid #eff2fa;
	}

	.col-lg-3 {
		.userheadertx {
			width: 6vw !important;
			height: 6vw !important;
		}
	}
}

.userx {
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-wrap: wrap;
	height: 70vh;
	min-height: 70vh;
	overflow: hidden;

	.usercards {
		background: #fff;
		// border: 1px solid;
		border-radius: 7px;
		height: 100%;

		img.usercardbg {
			width: 100%;
		}

		.usercard {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			align-content: center;

			/* 设置持续时间和动画函数 */
			.v-enter-active,
			.v-leave-active {
				transition: all 0.8s ease;
			}

			.v-enter,
			.v-leave-to {
				transform: translateX(100px);
				opacity: 0;
			}

			.userheader {
				text-align: center;
				width: 100%;
				padding: 0 0.8rem;
				box-sizing: border-box;

				img {
					position: relative;
					left: 0;
					top: -4rem;
					width: 6vw;
					height: 6vw;
				}

				span.pens {
					display: block;
					position: relative;
					width: 2rem;
					height: 2rem;
					border-radius: 50%;
					border: 1px solid;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #0acf97;
					color: #fff;
					font-size: 1rem;
					font-weight: 800;
					left: 60%;
					top: -6rem;
				}

				.usercardts {
					position: relative;
					top: -5rem;
					width: 100%;

					.name {
						font-size: 1rem;
						color: #333;
					}

					.student {
						margin: 0.8rem 0;
						color: #ff8300;
						font-size: 0.8rem;
					}

					.qma {
						width: 100%;
						// text-align: left;
						overflow: inherit;
						white-space: inherit;
						text-overflow: inherit;
					}

					.qmedit {
						margin-top: 1rem;
						display: flex;
						align-items: center;
						justify-content: center;

						input {
							border: 1px solid #5891aa;
							border-radius: 10rem;
							padding: 0.4rem 0.4rem;
							box-sizing: border-box;
						}

						span {
							cursor: pointer;
							margin: 0 0.4rem;
							font-size: 1rem;
							border-radius: 50%;
						}

						span:nth-of-type(1) {
							color: #fff;
							background: #55ff7f;
						}

						span:nth-of-type(2) {
							color: #fff;
							background: #ff4621;
						}
					}

					.editqm:hover {
						background-color: #ececec;
					}

					.editqm {
						margin-top: 1.5rem;
						border: 1px solid #5891aa;
						padding: 0.4rem 0.8rem;
						border-radius: 5px;

						span {
							font-weight: 800;
						}
					}
				}
			}
		}
	}
}

.usertexts {
	border-left: 15px solid #eff2fa;
	height: 100%;
	background: #fff;

	.usertext {
		padding: 1rem 2rem;
		background: #fff;
		border-radius: 5px;
	}

	.sex {
		/deep/ label {
			margin-bottom: 0 !important;
		}
	}

	.useript {
		label {
			display: block;
			margin-bottom: 1rem;

			p {
				margin-bottom: 0.4rem;
			}
		}

		.save {
			background: #0acf97;
			color: #fff;
			padding: 0.6rem 2rem;
			border-radius: 5px;
		}

		.save:hover {
			background: #0beeaa;
		}

		.ouone {
			width: 35vw;
			text-align: center;
			margin: 1rem 0;

			span {
				display: block;
				padding: 4rem;
				font-size: 7rem;
				color: #ccc;
				border: 1px dashed #ccc;
			}
		}
	}

	ul {
		display: flex;
		align-items: center;
		margin-bottom: 1rem;

		li {
			width: 15%;
			text-align: center;
			height: 2rem;
			line-height: 2rem;
		}

		li.usertexttext {
			background-color: #5891aa;
			color: #fff;
			font-size: 0.8rem;
			border-radius: 5px;
		}
	}
}

.form-control {
	font-weight: 500;
}

.tsleiou {
	/* 设置持续时间和动画函数 */
	.v-enter-active,
	.v-leave-active {
		transition: all 0.8s ease;
	}

	.v-enter,
	.v-leave-to {
		transform: translateX(-100px);
		opacity: 0;
	}
}

// // 截图 样式给不上会出现NAN*NAN的情况
// .cropper-content {
//     .cropper {
//         width: auto;
//         height: 300px;
//     }
// }
</style>

<template>
	<div ref="homes">
		<titles titlename="个人信息" titlecontent="这里可以编辑个人信息" :mbx="paths"></titles>
		<div class="userx" :class="{ isfives: ishfelves }">
			<div class="usercards col-xs-12 col-sm-12 col-md-12 col-lg-3">
				<div class="usercard">
					<img class="usercardbg" src="./../../images/userbg.svg" alt="" />
					<div class="userheader" style="height: 24vh;">
						<img :class="{ isfivesimg: ishfelves }" class="userheadertx" v-if="users.ui_photoPath" :src="users.ui_photoPath" alt="" />
						<img :class="{ isfivesimg: ishfelves }" v-else class="userheadertx" src="../../images/header.jpg" alt="" />
						<input type="file" ref="file" accept=".png,.jpg" ID="fileSelect" runat="server" @change="preview" style="display: none" />
						<span @click="getheadertx()" style="cursor: pointer;" class="el-icon-edit pens"></span>
						<div class="usercardts">
							<p class="name">{{ users.ui_userName }}</p>
							<p class="student">{{ users.ut_Name }}</p>
							<div class="qma">
								{{ users.ui_signature }}
								<transition>
									<div class="qmedit" v-if="qmedit == 1">
										<input v-model="usersr.uisignature" placeholder="请输人签名" type="text" />
										<el-tooltip class="item" effect="dark" content="点击保存" placement="top-start">
											<span class="el-icon-check" @click="changesignture()"></span>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="点击取消" placement="top-start">
											<span class="el-icon-close" @click="qmedit = 0"></span>
										</el-tooltip>
									</div>
								</transition>
							</div>
							<transition class="tsleiou">
								<button class="editqm" v-if="qmedit == 0" @click="qmedit = 1">
									<span class="el-icon-edit"></span>
									编辑签名
								</button>
							</transition>
						</div>
					</div>
				</div>
			</div>
			<div class="usertexts col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<div class="usertext">
					<ul>
						<li style="cursor: pointer;" :class="{ usertexttext: usertabnam == 1 }" @click="usertabnam = 1">个人信息</li>
						<li style="cursor: pointer;" :class="{ usertexttext: usertabnam == 2 }" @click="usertabnam = 2">修改密码</li>
						<!-- <li :class="{'usertexttext':usertabnam==3}" @click="usertabnam=3">
							个性背景
						</li> -->
					</ul>

					<div class="useript" v-if="usertabnam == 1">
						<form>
							<label>
								<p>
									<span style="color: red;">*</span>
									真实姓名
								</p>
								<input v-model="usersr.ui_realName" type="text" class="form-control" placeholder="请输入真实姓名" />
							</label>
							<label>
								<p>
									<span style="color: red;">*</span>
									学号
								</p>
								<input v-model="usersr.ui_joyNumber" type="text" class="form-control" placeholder="请输入学号" />
							</label>
							<!-- <label>
								<p>
									<span style="color: red;">*</span>
									身份证
								</p>
								<input v-model="usersr.ui_cards" type="text" class="form-control" @blur="isCardNo(usersr.ui_cards)" placeholder="请输入身份证" maxlength="18" />
							</label> -->
							<label class="sex">
								<p>
									<span style="color: red;">*</span>
									性别：
								</p>
								<div style="display: flex;align-items: center;">
									<el-radio v-model="radio" label="1">男</el-radio>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<el-radio v-model="radio" label="0">女</el-radio>
								</div>
							</label>
							<label>
								<p>
									<span style="color: red;">*</span>
									手机号码
								</p>
								<input v-model="usersr.ui_mobile" type="tel" class="form-control" placeholder="请输入手机号码" maxlength="11" />
							</label>
							<label>
								<p>
									<span style="color: red;">*</span>
									邮箱地址
								</p>
								<input v-model="usersr.ui_email" type="email" class="form-control" placeholder="请输入邮箱地址" />
							</label>
							<!-- <label>
								<p>
									<span style="color: red;">*</span>
									所属班级
								</p>
								<select v-model="usersr.cla_guid" class="form-control" id="exampleFormControlSelect1">
									<option value="">-- 请选择班级 --</option>
									<option v-for="(item, index) in classscList" :key="index" :label="item.cla_name" :value="item.cla_guid">{{ item.cla_name }}</option>
								</select>
							</label> -->
							<!-- <label>
								<p>所属专业</p>
								<select v-model="usersr.pro_guid" class="form-control" id="exampleFormControlSelect1">
									<option value=""> -- 请选择专业 --</option>
									<option v-for="(item,index) in classlist" :key="index" :label="item.pro_name" :value="item.pro_guid">
										{{item.pro_name}}
									</option>
								</select>
							</label> -->
							<button @click="getUpdaterInfo()" type="button" class="save" v-preventReClick>保存</button>
						</form>
					</div>

					<div class="useript" v-if="usertabnam == 2">
						<form>
							<label>
								<p>原密码</p>
								<input v-model="urses.uipassword" type="password" class="form-control" placeholder="请输入原密码" />
							</label>
							<label>
								<p style="display: flex;align-items: center;">
									<span style="font-size: 1rem;margin-right: 1rem;">新密码</span>
									<span
										v-if="ispassads"
										style="display: block;text-align: center;color: red;font-size: 0.8rem;"
										:style="{ color: ispassad == 0 ? 'red' : ispassad == 2 ? '#E5986A' : ispassad == 3 ? 'green' : 'gainsboro' }"
									>
										{{ passadetext }}
									</span>
								</p>
								<div><input v-model="urses.newpassword1" type="password" class="form-control" placeholder="请输入新密码" @input="changepasd" /></div>
							</label>
							<label>
								<p>再次输入新密码</p>
								<input v-model="urses.newpassword2" type="password" class="form-control" placeholder="再次输入新密码" />
							</label>

							<button @click="forgetpassword()" type="button" class="save" v-preventReClick>保存</button>
							<!-- 	<button @click="resvesa()" type="button"
								style="margin-left: 1rem;background-color: #00aaff;" class="save ibecall">一键重置</button> -->
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- 上传图片截取事件 -->
		<el-dialog title="修改头像" :visible.sync="centerDialogVisible" center width="80%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;flex-direction: column;">
					<div style="width: 30rem;height: 30rem;">
						<vueCropper
							ref="cropper"
							:img="img"
							:outputSize="option.outputSize"
							:outputType="option.outputType"
							:info="option.info"
							:full="option.full"
							:canMove="option.canMove"
							:canMoveBox="option.canMoveBox"
							:original="option.original"
							:autoCrop="option.autoCrop"
							:autoCropWidth="option.autoCropWidth"
							:autoCropHeight="option.autoCropHeight"
							:fixedBox="option.fixedBox"
							@realTime="realTime"
						></vueCropper>
					</div>
				</div>

				<div
					style="width: 30rem;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-left: 1rem;"
				>
					<img :src="corappurl" alt="" style="width: 10rem;height: 10rem;border-radius: 50%;border: 1px solid #ccc;" />
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changeheadimg()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { userUploadAvatar, userUpdatePwd } from '@/request/api/home.js';
import { getUserSingle, getUpdateUserInfo, GetbjGetSchoolList, GetzyProfList } from '@/request/api/mange/mange.js';
import { setResetPassword, setUploadAvatar, userUpdateUserSignature } from '@/request/api/userapi/studenthome.js';
import { GetyyGetClassList } from '@/request/api/dataorder/dataprder.js';
import AppOptions from '../../config/AppOptions.vue';
import { ishfelve } from '@/utils/utils';

import { VueCropper } from 'vue-cropper';

import $ from 'jquery';

export default {
	data() {
		return {
			usertabnam: 1,
			radio: '1',
			// 标题组件
			paths: [
				{
					path: 'user/ChangeUser',
					name: '个人信息'
				}
			],
			// 编辑签名
			qmedit: 0,
			img: '',
			// 用户信息
			users: {},
			usersr: {
				cla_guid: ''
			},
			// 院校和班级列表
			schoolList: [],
			classlist: [],
			classscList: [],
			urses: {
				uipassword: '',
				newpassword1: '',
				newpassword2: ''
			},
			ishfelves: '',
			passadetext: '',
			ispassad: 0,
			ispassads: false,
			// 截取图片
			centerDialogVisible: false,
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 200, // 默认生成截图框宽度
				autoCropHeight: 200, // 默认生成截图框高度
				fixedBox: false, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [5, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			corappurl: '',
			newfilenow: ''
		};
	},
	created() {
		AppOptions.appEmpty = false;
		this.ishfelves = ishfelve();
		if (this.$route.query.passags == 1) {
			this.usertabnam = 2;
		}
		
	},
	watch: {},
	beforeMount() {
		this.GetbjGetscol();
		this.getusers();
	},
	mounted() {
		let homestop = $(this.$refs.homes).offset().top;
		let homesleft = $(this.$refs.homes).offset().left;
		if (homestop < 25 && localStorage.getItem('token') && homesleft < 200) {
			// console.log("刷新页面")
			// if (localStorage.getItem('token')) {
			// 	window.location.reload();
			// }
		}
	},
	updated() {},
	methods: {
		//检查号码是否符合规范，包括长度，类型
		isCardNo(data) {
			//身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
			if (reg.test(data) === false) {
				this.$message({
					message: '身份证号码格式错误',
					type: 'error'
				});
				return false;
			}
			return true;
		},
		// 真实图片
		realTime(data) {
			// console.log(data);
			this.previews = data;
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		},
		// 头像上传
		changeheadimg() {
			var form_data = new FormData();
			// console.log(this.newfilenow)
			form_data.append('filename', this.newfilenow);
			form_data.append('ui_guid', localStorage.getItem('uiguid'));
			// console.log(form_data)

			setUploadAvatar(form_data).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					this.centerDialogVisible = false;
					this.$parent.$children[0].getuservs();
					this.getusers();
				} else {
					this.$message(res.data.msg, '格式默认人为jpg/png');
				}
			});
		},

		changepasd() {
			var a = this.urses.newpassword1 + '';
			this.ispassads = true;
			var reg = /^[0-9]{6,16}$|^[a-zA-Z]{6,16}$/; //全是数字或全是字母 6-16个字符
			var reg1 = /^[A-Za-z0-9]+$/; //数字、26个英文字母 6-16个字符
			var reg2 = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_+\-]{6,16}$/; // 由数字、26个英文字母或者下划线组成的字符串 6-16个字符
			if (a.length == 0) {
				this.passadetext = '密码不能为空！';
			} else if (a.length < 6) {
				this.passadetext = '密码长度小于6个字符!';
			} else if (reg.test(a)) {
				this.passadetext = '全是数字或字母';
			} else if (reg1.test(a)) {
				this.ispassad = 2;
				this.passadetext = '中级';
			} else if (reg2.test(a)) {
				this.ispassad = 3;
				this.passadetext = '高级';
			}
			// console.log(this.ispassad,'获取类型',reg.test(a),reg1.test(a),)
			
			
		},
		// 签名修改
		changesignture() {
			let userrsigatrue = {
				ui_guid: localStorage.getItem('uiguid'),
				ui_signature: this.usersr.uisignature
			};
			userUpdateUserSignature(userrsigatrue).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.qmedit = 0;
					this.getusers();
				} else {
					// this.$message(res.data.msg);
				}
			});
		},

		// 忘记密码
		forgetpassword() {
			// console.log(userUploadAvatar())
			let update = {
				ui_guid: localStorage.getItem('uiguid'),
				ui_password: this.urses.uipassword,
				new_password1: this.urses.newpassword1,
				new_password2: this.urses.newpassword2
			};
			// console.log(this.ispassad,this.urses.uipassword.length,this.urses.newpassword1.length,this.urses.newpassword2.length)
			
			if (this.ispassad != 0 && this.urses.uipassword.length !== 0 && this.urses.newpassword1.length !== 0 && this.urses.newpassword2.length !== 0) {
				userUpdatePwd(update).then(res => {
					// console.log(res)
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.$cookie.set('/%password/%', this.urses.newpassword1);
						this.urses = {};
					} else {
						// this.$message(res.data.msg)
					}
				});
			} else {
				this.$message('请输入正确的密码！');
			}
		},

		getusers() {
			getUserSingle(localStorage.getItem('uiguid')).then(res => {
				// console.log(res)
				this.users = res.data.data;

				this.usersr = JSON.parse(JSON.stringify(res.data.data));
				this.usersr.cla_guid = this.usersr.cla_guid ?? '';
				if (this.usersr.ui_sex) {
					this.radio = '1';
				} else {
					this.radio = '0';
				}
				this.usersr.SchoolName = this.usersr.SchoolName;
				this.usersr.ClaName = this.usersr.ClaName;
				this.usersr.uisignature = this.usersr.ui_signature;
			});
		},
		// 获取学校和专业班级
		GetbjGetscol() {
			GetbjGetSchoolList().then(res => {
				// console.log(res, "学校")
				this.schoolList = res.data.data;
			});
			GetzyProfList(localStorage.getItem('siguid')).then(res => {
				// console.log(res, "专业")
				this.classlist = res.data.data;
			});
			GetyyGetClassList(localStorage.getItem('siguid')).then(res => {
				// console.log(res, "班级")
				this.classscList = res.data.data;
			});
		},
		// 修改用户信息
		getUpdaterInfo() {
			let users = {
				ui_guid: this.usersr.ui_guid,
				ui_email: this.usersr.ui_email,
				ui_realName: this.usersr.ui_realName,
				ui_sex: this.radio,
				ui_mobile: this.usersr.ui_mobile,
				ui_signature: this.usersr.ui_signature,
				si_guid: this.usersr.si_guid,
				cla_guid: this.usersr.cla_guid,
				ui_cards: this.usersr.ui_cards,
				ui_joyNumber: this.usersr.ui_joyNumber,
				ut_guid: ''
			};

			// this.$options.methods.isCardNo(users.ui_cards);

			getUpdateUserInfo(users).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
					this.getusers();
				} else {
					this.$message(res.data.msg);
				}
			});
		},

		// 一键重置密码
		resvesa() {
			setResetPassword().then(res => {
				// console.log(res)
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你，' + res.data.msg,
						type: 'success'
					});
				} else {
					// this.$message(res.data.msg);
				}
			});
		},

		getheadertx() {
			this.$refs.file.click();
		},
		// fromdata装换
		getFormData(object) {
			const formData = new FormData();
			Object.keys(object).forEach(key => {
				const value = object[key];
				if (Array.isArray(value)) {
					value.forEach((subValue, i) => formData.append(key + `[${i}]`, subValue));
				} else {
					formData.append(key, object[key]);
				}
			});
			return formData;
		},

		preview: function(e) {
			let _this = this;
			let file = e.target.files[0];
			if (!file) {
				return;
			}
			var imgs = '';
			var reader = new FileReader();
			reader.readAsDataURL(e.target.files[0]);
			reader.onload = function() {
				imgs = this.result;
				_this.img = imgs;
			};
			_this.centerDialogVisible = true;

			// const fileInput = document.getElementById('fileSelect');
			// fileInput.value = '';
			this.$refs.file.value = '';
		},
		upload(img) {
			// console.log("这个是方法获取的", img)
			return img;
		},
		getheadertx1() {
			this.$refs.file1.click();
		}
	},
	components: {
		titles,
		VueCropper
	}
};
</script>
